/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CreateAndroidDevicePayload } from '../models';
// @ts-ignore
import type { CreateIOSDevicePayload } from '../models';
// @ts-ignore
import type { CreateWebDevicePayload } from '../models';
// @ts-ignore
import type { RegisterIOSDevice200Response } from '../models';
// @ts-ignore
import type { RegisterWebDevice200Response } from '../models';
// @ts-ignore
import type { UpdateSseSessionPayload } from '../models';
// @ts-ignore
import type { UpdateWebSession200Response } from '../models';
/**
 * DeviceRegistrationApi - axios parameter creator
 */
export const DeviceRegistrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This registers a new Android device, with a push token as body. If a `?deviceId` is specified, instead of creating a new device, the current push token is replaced inside this device registration. If the `deviceId` is not found, a new device is created.
         * @summary Register a new Android device
         * @param {CreateAndroidDevicePayload} createAndroidDevicePayload 
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAndroidDevice: async (createAndroidDevicePayload: CreateAndroidDevicePayload, deviceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAndroidDevicePayload' is not null or undefined
            assertParamExists('registerAndroidDevice', 'createAndroidDevicePayload', createAndroidDevicePayload)
            const localVarPath = `/api/nora/device/registration/android`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAndroidDevicePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This registers a new iOS device, with a push token as body. If a `?deviceId` is specified, instead of creating a new device, the current push token is replaced inside this device registration. If the `deviceId` is not found, a new device is created.
         * @summary Register a new iOS device
         * @param {CreateIOSDevicePayload} createIOSDevicePayload 
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerIOSDevice: async (createIOSDevicePayload: CreateIOSDevicePayload, deviceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createIOSDevicePayload' is not null or undefined
            assertParamExists('registerIOSDevice', 'createIOSDevicePayload', createIOSDevicePayload)
            const localVarPath = `/api/nora/device/registration/ios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createIOSDevicePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary registerWebDevice
         * @param {CreateWebDevicePayload} createWebDevicePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWebDevice: async (createWebDevicePayload: CreateWebDevicePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWebDevicePayload' is not null or undefined
            assertParamExists('registerWebDevice', 'createWebDevicePayload', createWebDevicePayload)
            const localVarPath = `/api/nora/device/registration/web`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWebDevicePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateWebSession
         * @param {string} sessionId 
         * @param {UpdateSseSessionPayload} updateSseSessionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebSession: async (sessionId: string, updateSseSessionPayload: UpdateSseSessionPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('updateWebSession', 'sessionId', sessionId)
            // verify required parameter 'updateSseSessionPayload' is not null or undefined
            assertParamExists('updateWebSession', 'updateSseSessionPayload', updateSseSessionPayload)
            const localVarPath = `/api/nora/device/registration/web/sse/{sessionId}`
                .replace('{sessionId}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSseSessionPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceRegistrationApi - functional programming interface
 */
export const DeviceRegistrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceRegistrationApiAxiosParamCreator(configuration)
    return {
        /**
         * This registers a new Android device, with a push token as body. If a `?deviceId` is specified, instead of creating a new device, the current push token is replaced inside this device registration. If the `deviceId` is not found, a new device is created.
         * @summary Register a new Android device
         * @param {CreateAndroidDevicePayload} createAndroidDevicePayload 
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerAndroidDevice(createAndroidDevicePayload: CreateAndroidDevicePayload, deviceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterIOSDevice200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerAndroidDevice(createAndroidDevicePayload, deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceRegistrationApi.registerAndroidDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This registers a new iOS device, with a push token as body. If a `?deviceId` is specified, instead of creating a new device, the current push token is replaced inside this device registration. If the `deviceId` is not found, a new device is created.
         * @summary Register a new iOS device
         * @param {CreateIOSDevicePayload} createIOSDevicePayload 
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerIOSDevice(createIOSDevicePayload: CreateIOSDevicePayload, deviceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterIOSDevice200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerIOSDevice(createIOSDevicePayload, deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceRegistrationApi.registerIOSDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary registerWebDevice
         * @param {CreateWebDevicePayload} createWebDevicePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerWebDevice(createWebDevicePayload: CreateWebDevicePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterWebDevice200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerWebDevice(createWebDevicePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceRegistrationApi.registerWebDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateWebSession
         * @param {string} sessionId 
         * @param {UpdateSseSessionPayload} updateSseSessionPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWebSession(sessionId: string, updateSseSessionPayload: UpdateSseSessionPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateWebSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWebSession(sessionId, updateSseSessionPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceRegistrationApi.updateWebSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceRegistrationApi - factory interface
 */
export const DeviceRegistrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceRegistrationApiFp(configuration)
    return {
        /**
         * This registers a new Android device, with a push token as body. If a `?deviceId` is specified, instead of creating a new device, the current push token is replaced inside this device registration. If the `deviceId` is not found, a new device is created.
         * @summary Register a new Android device
         * @param {DeviceRegistrationApiRegisterAndroidDeviceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerAndroidDevice(requestParameters: DeviceRegistrationApiRegisterAndroidDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterIOSDevice200Response> {
            return localVarFp.registerAndroidDevice(requestParameters.createAndroidDevicePayload, requestParameters.deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * This registers a new iOS device, with a push token as body. If a `?deviceId` is specified, instead of creating a new device, the current push token is replaced inside this device registration. If the `deviceId` is not found, a new device is created.
         * @summary Register a new iOS device
         * @param {DeviceRegistrationApiRegisterIOSDeviceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerIOSDevice(requestParameters: DeviceRegistrationApiRegisterIOSDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterIOSDevice200Response> {
            return localVarFp.registerIOSDevice(requestParameters.createIOSDevicePayload, requestParameters.deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary registerWebDevice
         * @param {DeviceRegistrationApiRegisterWebDeviceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWebDevice(requestParameters: DeviceRegistrationApiRegisterWebDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterWebDevice200Response> {
            return localVarFp.registerWebDevice(requestParameters.createWebDevicePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateWebSession
         * @param {DeviceRegistrationApiUpdateWebSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWebSession(requestParameters: DeviceRegistrationApiUpdateWebSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateWebSession200Response> {
            return localVarFp.updateWebSession(requestParameters.sessionId, requestParameters.updateSseSessionPayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for registerAndroidDevice operation in DeviceRegistrationApi.
 */
export interface DeviceRegistrationApiRegisterAndroidDeviceRequest {
    readonly createAndroidDevicePayload: CreateAndroidDevicePayload

    readonly deviceId?: string
}

/**
 * Request parameters for registerIOSDevice operation in DeviceRegistrationApi.
 */
export interface DeviceRegistrationApiRegisterIOSDeviceRequest {
    readonly createIOSDevicePayload: CreateIOSDevicePayload

    readonly deviceId?: string
}

/**
 * Request parameters for registerWebDevice operation in DeviceRegistrationApi.
 */
export interface DeviceRegistrationApiRegisterWebDeviceRequest {
    readonly createWebDevicePayload: CreateWebDevicePayload
}

/**
 * Request parameters for updateWebSession operation in DeviceRegistrationApi.
 */
export interface DeviceRegistrationApiUpdateWebSessionRequest {
    readonly sessionId: string

    readonly updateSseSessionPayload: UpdateSseSessionPayload
}

/**
 * DeviceRegistrationApi - object-oriented interface
 */
export class DeviceRegistrationApi extends BaseAPI {
    /**
     * This registers a new Android device, with a push token as body. If a `?deviceId` is specified, instead of creating a new device, the current push token is replaced inside this device registration. If the `deviceId` is not found, a new device is created.
     * @summary Register a new Android device
     * @param {DeviceRegistrationApiRegisterAndroidDeviceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerAndroidDevice(requestParameters: DeviceRegistrationApiRegisterAndroidDeviceRequest, options?: RawAxiosRequestConfig) {
        return DeviceRegistrationApiFp(this.configuration).registerAndroidDevice(requestParameters.createAndroidDevicePayload, requestParameters.deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This registers a new iOS device, with a push token as body. If a `?deviceId` is specified, instead of creating a new device, the current push token is replaced inside this device registration. If the `deviceId` is not found, a new device is created.
     * @summary Register a new iOS device
     * @param {DeviceRegistrationApiRegisterIOSDeviceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerIOSDevice(requestParameters: DeviceRegistrationApiRegisterIOSDeviceRequest, options?: RawAxiosRequestConfig) {
        return DeviceRegistrationApiFp(this.configuration).registerIOSDevice(requestParameters.createIOSDevicePayload, requestParameters.deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary registerWebDevice
     * @param {DeviceRegistrationApiRegisterWebDeviceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerWebDevice(requestParameters: DeviceRegistrationApiRegisterWebDeviceRequest, options?: RawAxiosRequestConfig) {
        return DeviceRegistrationApiFp(this.configuration).registerWebDevice(requestParameters.createWebDevicePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateWebSession
     * @param {DeviceRegistrationApiUpdateWebSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateWebSession(requestParameters: DeviceRegistrationApiUpdateWebSessionRequest, options?: RawAxiosRequestConfig) {
        return DeviceRegistrationApiFp(this.configuration).updateWebSession(requestParameters.sessionId, requestParameters.updateSseSessionPayload, options).then((request) => request(this.axios, this.basePath));
    }
}

